export default __webpack_public_path__ + "static/media/auth2.8fc99dc8.png";